{
  "chapel": {
    "u0": -16.25,
    "chordU": 16.5,
    "vc": -33.2,
    "half": 4,
    "eaveY": 12.5,
    "ridgeY": 18.2,
    "apse": "flat"
  },
  "belfry": {
    "u": 10.5,
    "v": -33.2,
    "radius": 0.45,
    "foot": 16.1,
    "eaves": 18.2,
    "tip": 23.2
  },
  "ranges": [
    {
      "id": "west-chapel-body",
      "u": -23.75,
      "v": -33.2,
      "angleDeg": 0,
      "length": 15,
      "width": 8,
      "eaves": 10.2,
      "ridge": 15.7,
      "floors": 3,
      "bays": 3,
      "roof": "slate",
      "passage": 0
    },
    {
      "id": "nes-wing",
      "u": -28.4,
      "v": -51,
      "angleDeg": 90,
      "length": 32.5,
      "width": 5.2,
      "eaves": 8.3,
      "ridge": 12.1,
      "floors": 2,
      "bays": 6,
      "roof": "slate",
      "passage": 0,
      "roofGables": {
        "centres": [-12, -4, 4, 12],
        "halfWidth": 0.65,
        "v0": 0.9,
        "v1": 2.6,
        "eaves": 11.1,
        "ridge": 12.3,
        "sill": 9.0,
        "top": 10.1
      }
    },
    {
      "id": "canal-gate-wing",
      "u": 15.5,
      "v": -52,
      "angleDeg": 90,
      "length": 26,
      "width": 4.6,
      "eaves": 5.5,
      "ridge": 8.7,
      "floors": 2,
      "bays": 5,
      "roof": "tile",
      "passage": 3,
      "passageU": -2
    },
    {
      "id": "southern-cross-wing",
      "u": -7.2,
      "v": -71,
      "angleDeg": 0,
      "length": 49,
      "width": 5.8,
      "eaves": 6.8,
      "ridge": 10.8,
      "floors": 2,
      "bays": 9,
      "roof": "tile",
      "passage": 0
    }
  ],
  "floors": [
    {
      "ring": [
        [-25.6, -68],
        [12.9, -68],
        [12.9, -37.5],
        [-25.6, -37.5]
      ],
      "height": 0.025,
      "garden": false
    },
    {
      "ring": [
        [-23, -65],
        [10.5, -65],
        [10.5, -40.2],
        [-23, -40.2]
      ],
      "height": 0.04,
      "garden": true
    }
  ],
  "walls": [
    {
      "to": [17.6, -68.1],
      "width": 0.3,
      "height": 2.2,
      "from": [17.6, -65]
    },
    {
      "to": [-31, -73.8],
      "width": 0.3,
      "height": 2.2,
      "from": [-31, -67.25]
    },
    {
      "to": [-28.5, -73.8],
      "width": 0.3,
      "height": 2.2,
      "from": [-31, -73.8]
    }
  ],
  "note": "The 1538 painting and 1544 woodcut guide a distinct northern chapel beside Magdalena’s southern chapel, attached western body, unequal Nes and lower canal ranges, southern cross wing and open green court. The 1760 view is a later interpretation derived from Anthonisz. 1544, not an independent medieval survey. All dimensions, heights, windows, gablets, belfry, hidden connections, walls, soil boundaries, gate and precinct edge are estimated. The shared approach with Magdalena remains private and stops at the Nes boundary; no 1569 Sint Barberenstraat is backdated. The exact 1431 double gate and 1527 settled boundary are not recovered. The southern reservation clears Kuiperssteeg and does not merge this convent into Sint Clara or the Heiligeweg Clarissen."
}
